import RevenueStats from './RevenueStats';

export default function DashboardCards({ summary }) {
  if (!summary) return null;
  const cards = [['Orders', summary.orders], ['Pending fulfilment', summary.pendingOrders], ['Products', summary.products], ['Low stock', summary.lowStock], ['Customers', summary.customers], ['Refund requests', summary.refundRequests]];
  return (
    <section aria-label="Store summary" className="admin-metrics">
      {cards.map(([label, value]) => <article className="admin-metric" key={label}><span>{label}</span><strong>{value || 0}</strong></article>)}
      <RevenueStats amount={summary.paidRevenue} />
    </section>
  );
}
